<template lang="pug">
  .timer.box(style="width: 80%; margin: 20px auto")
    .clock
      radial-clock(:max="duration", :value="time", :label="timePretty")

    .field.has-addons(style="justify-content: center")
      p.control
        button(@click="toggle", v-bind:class="{ 'is-primary': !running && time > 0, 'is-warning': running && time > 0}").button
          span.icon
            fa-icon(:icon="running ? 'pause' : 'play'").fa
          span(v-if="!running") Start
          span(v-if="running") Stop

      p.control
        button(@click="reset").button.is-inverted
          span Reset

</template>

<script>

import RadialClock from '@/components/RadialClock.vue'

function zeroPad (s) {
  let r = '' + s.toFixed(0)
  while (r.length < 2) { r = '0' + r }
  return r
}

export function prettyTime (s) {
  s = Math.round(s)
  let minutes = (s - s % 60) / 60
  let seconds = s % 60

  return zeroPad(minutes) + ':' + zeroPad(seconds)
}

export default {
  name: 'Timer',
  components: { RadialClock },
  props: {
    duration: {
      type: Number,
      default: 5
    }
  },
  watch: {
    running (vNew, vOld) {
      this.$emit('update:running', vNew)

      // guard against refreshing
      if (vNew) {
        window.onbeforeunload = () => 'Timer running! Are you sure you want to leave?'
      } else {
        window.onbeforeunload = null
      }
    },
    duration () {
      this.reset()
    }
  },
  data () {
    return {
      time: this.duration,
      timer: null,
      timeStart: null,
      timeIncrements: 10
    }
  },
  computed: {
    timePretty () {
      return prettyTime(this.time)
    },
    running () {
      return !!this.timer
    }
  },
  methods: {
    toggle () {
      if (this.running) {
        this.stop()
      } else {
        this.start()
      }
    },
    start () {
      this.stop()

      this.timeStart = new Date()
      this.$emit('start')

      if (this.time <= 0) { return }

      this.timer = window.setInterval(() => {
        let elapsed = new Date() - this.timeStart

        this.time = this.duration - elapsed / 1000

        if (this.time <= 0) {
          this.time = 0
          this.stop()
          this.$emit('finish')
        }
      }, 1000 / this.timeIncrements)
    },
    stop () {
      if (this.timer) {
        window.clearInterval(this.timer)
      }
      this.timer = null
    },
    reset () {
      this.stop()
      this.time = this.duration
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
</style>
